<template>
    <div class="p-5 flex ">

        <VueMultiselect
            v-model=" userAutocomplete.selection"
            :options="userAutocomplete.options"
            placeholder="Scegli utente"
            class="next-vue-multiselect-single"
            track-by="id"
            label="email"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :internal-search="false"
            @search-change="userAutocomplete.search"
        >
        </VueMultiselect>
        <NextButton @click="send">invia</NextButton>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import {mapActions, mapGetters} from 'vuex';
import meManager from "../api/Me";
import NextButton from "@/components/NextButton.vue";
import Autocomplete from "@/setup/Autocomplete";
import userManager from "../api/Users";
import {setToken} from "@/api/api";

@Options({
    name:'LoginAsUser',
    components: {NextButton},
    computed: {
        ...mapGetters([
            'isAuthenticated',
        ]),

    },
    methods: {
        ...mapActions([
            'fetchUser',
        ]),
    }
})
export default class LoginAsUser extends Vue {

    userAutocomplete: any = setup(() => Autocomplete(userManager))
    send() {
        meManager.loginAsUser(this.userAutocomplete.selection.email).then((response)=>{
            const token = response.data?.token
            if (token) {
                localStorage.setItem('next-token', token);
                setToken(token);
                //@ts-ignore
                this.$store.dispatch('init').then(() => {
                    //@ts-ignore
                    this.$router.replace({name: 'Dashboard'})
                })
            }
        })
    }
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
